import React, { useEffect, useState } from 'react'

const PWAInstallButton: React.FC = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null)
  const [canInstall, setCanInstall] = useState(false)

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setCanInstall(true)
    }
    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  if (!canInstall) return null

  return (
    <button
      onClick={async () => {
        if (!deferredPrompt) return
        deferredPrompt.prompt()
        const { outcome } = await deferredPrompt.userChoice
        if (outcome !== 'accepted') {
          // If dismissed, allow showing again later
          setCanInstall(true)
        } else {
          setCanInstall(false)
        }
        setDeferredPrompt(null)
      }}
      className="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 shadow"
      title="Instalar aplicación"
    >
      Instalar app
    </button>
  )
}

export default PWAInstallButton


